import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { ApolloProvider } from '@apollo/client'
import { client } from './lib/apollo'
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { CssBaseline } from '@mui/material';
import { setupErrorHandler } from './errorHandler'
import { WhatsAppProvider } from './contexts/WhatsAppContext'

// Configurar manejador de errores global
setupErrorHandler();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <WhatsAppProvider>
          <App />
        </WhatsAppProvider>
      </ThemeProvider>
    </ApolloProvider>
  </React.StrictMode>,
)
